import { render } from "./Deposit.vue?vue&type=template&id=79521bfd"
import script from "./Deposit.vue?vue&type=script&lang=js"
export * from "./Deposit.vue?vue&type=script&lang=js"
script.render = render

export default script